/* ==========================================================================
   EastCoastArtStudio theme — interactive behavior
   Vanilla JS, no dependencies. Each feature initializes only when its
   markup exists on the page.
   ========================================================================== */
(function () {
  'use strict';

  document.documentElement.classList.remove('no-js');

  var withDelimiters = function (cents, precision, thousands, decimal) {
    var parts = (Math.round(cents) / 100).toFixed(precision).split('.');
    var whole = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
    return parts[1] ? whole + decimal + parts[1] : whole;
  };

  /* Renders cents through shop.money_format. Every placeholder Shopify defines
     is handled, not just {{amount}}: a store on a comma-separator or
     no-decimals format would otherwise see the literal token appear the moment
     a price is rendered here rather than by Liquid's `money` filter. */
  var formatMoney = function (cents) {
    var format = window.theme && window.theme.moneyFormat ? window.theme.moneyFormat : '${{amount}}';
    return format.replace(/\{\{\s*(\w+)\s*\}\}/g, function (token, name) {
      switch (name) {
        case 'amount': return withDelimiters(cents, 2, ',', '.');
        case 'amount_no_decimals': return withDelimiters(cents, 0, ',', '.');
        case 'amount_with_comma_separator': return withDelimiters(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return withDelimiters(cents, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return withDelimiters(cents, 2, "'", '.');
        case 'amount_with_space_separator': return withDelimiters(cents, 2, ' ', ',');
        case 'amount_no_decimals_with_space_separator': return withDelimiters(cents, 0, ' ', ',');
        default: return token;
      }
    });
  };

  /* ------------------------------------------------------------------
     Announcement bar rotation
     ------------------------------------------------------------------ */
  document.querySelectorAll('[data-announcement-bar]').forEach(function (bar) {
    var slides = bar.querySelectorAll('.announcement-bar__slide');
    if (slides.length < 2) return;
    var index = 0;
    var interval = parseInt(bar.dataset.interval || '5000', 10);
    var timer = null;

    var show = function (i) {
      index = (i + slides.length) % slides.length;
      slides.forEach(function (s, j) {
        s.setAttribute('aria-hidden', j === index ? 'false' : 'true');
      });
    };

    var play = function () {
      stop();
      timer = setInterval(function () { show(index + 1); }, interval);
    };
    var stop = function () {
      if (timer) clearInterval(timer);
      timer = null;
    };

    bar.querySelectorAll('[data-announcement-prev]').forEach(function (b) {
      b.addEventListener('click', function () { show(index - 1); play(); });
    });
    bar.querySelectorAll('[data-announcement-next]').forEach(function (b) {
      b.addEventListener('click', function () { show(index + 1); play(); });
    });

    bar.addEventListener('mouseenter', stop);
    bar.addEventListener('mouseleave', play);
    show(0);
    play();
  });

  /* ------------------------------------------------------------------
     Details-based dropdowns: close on outside click / Escape
     ------------------------------------------------------------------ */
  document.addEventListener('click', function (e) {
    document.querySelectorAll('details[data-auto-close][open]').forEach(function (d) {
      if (!d.contains(e.target)) d.removeAttribute('open');
    });
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    document.querySelectorAll('details[data-auto-close][open]').forEach(function (d) {
      d.removeAttribute('open');
    });
    document.querySelectorAll('.drawer[open]').forEach(function (d) {
      closeDrawer(d);
    });
  });

  /* ------------------------------------------------------------------
     Drawers (mobile menu, search, cart)
     ------------------------------------------------------------------ */
  var FOCUSABLE =
    'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

  var focusableWithin = function (root) {
    return [].slice.call(root.querySelectorAll(FOCUSABLE)).filter(function (node) {
      // tabIndex < 0 excludes the search options: they are <a href> so they
      // match the selector, but they are deliberately out of the tab sequence
      // (the combobox drives them via aria-activedescendant). Counting them
      // would put the trap's "last" element on something Tab never reaches.
      return !node.hasAttribute('data-drawer-overlay') &&
             node.offsetParent !== null &&
             node.tabIndex >= 0;
    });
  };

  var openDrawer = function (drawer) {
    // VO frame add-ons are reconciled on the full cart. Route both header
    // cart opens and post-add opens there before changing drawer state.
    if (drawer.hasAttribute('data-cart-drawer') && drawer.dataset.cartUrl) {
      window.location.assign(drawer.dataset.cartUrl);
      return;
    }
    // Remembered so focus can go back where it came from — otherwise closing
    // drops the caret to <body> and keyboard users restart from the top.
    drawer.__drawerOpener = document.activeElement;
    drawer.setAttribute('open', '');
    document.body.style.overflow = 'hidden';
    var focusable = focusableWithin(drawer)[0];
    if (focusable) focusable.focus({ preventScroll: true });
  };

  var closeDrawer = function (drawer) {
    drawer.removeAttribute('open');
    if (!document.querySelector('.drawer[open]')) {
      document.body.style.overflow = '';
    }
    var opener = drawer.__drawerOpener;
    if (opener && document.contains(opener)) opener.focus({ preventScroll: true });
    drawer.__drawerOpener = null;
  };

  /* A drawer declaring aria-modal must actually contain the tab sequence;
     without this, Tab walks off into the page behind the overlay. */
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Tab') return;
    var drawer = document.querySelector('.drawer[open][data-focus-trap], .drawer[data-focus-trap][open]');
    if (!drawer) {
      var openDrawers = document.querySelectorAll('.drawer[open]');
      for (var i = 0; i < openDrawers.length; i++) {
        if (openDrawers[i].querySelector('[data-focus-trap]')) {
          drawer = openDrawers[i];
          break;
        }
      }
    }
    if (!drawer) return;
    var focusable = focusableWithin(drawer);
    if (!focusable.length) return;
    var first = focusable[0];
    var last = focusable[focusable.length - 1];
    // Focus outside the drawer entirely — a click on the panel's padding
    // resets activeElement to <body>, and without this the handler fell
    // through to the browser's default Tab and walked into the page behind
    // the overlay, leaving the trap permanently defeated.
    if (!drawer.contains(document.activeElement)) {
      e.preventDefault();
      (e.shiftKey ? last : first).focus();
      return;
    }
    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  });

  window.themeDrawers = { open: openDrawer, close: closeDrawer };

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-drawer-open]');
    if (opener) {
      var target = document.querySelector(opener.dataset.drawerOpen);
      if (target) {
        e.preventDefault();
        openDrawer(target);
      }
      return;
    }
    var closer = e.target.closest('[data-drawer-close], [data-drawer-overlay]');
    if (closer) {
      var drawer = closer.closest('.drawer');
      if (drawer) closeDrawer(drawer);
    }
  });

  /* ------------------------------------------------------------------
     Carousel arrows
     ------------------------------------------------------------------ */
  document.querySelectorAll('[data-carousel]').forEach(function (carousel) {
    var track = carousel.querySelector('.carousel__track');
    if (!track) return;
    var prev = carousel.querySelector('[data-carousel-prev]');
    var next = carousel.querySelector('[data-carousel-next]');

    var step = function () {
      var item = track.firstElementChild;
      if (!item) return track.clientWidth;
      var style = getComputedStyle(track);
      var gap = parseFloat(style.columnGap || style.gap || '16') || 16;
      return item.getBoundingClientRect().width + gap;
    };

    var update = function () {
      if (!prev || !next) return;
      var max = track.scrollWidth - track.clientWidth - 2;
      prev.toggleAttribute('disabled', track.scrollLeft <= 2);
      next.toggleAttribute('disabled', track.scrollLeft >= max);
    };

    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  });

  /* ------------------------------------------------------------------
     Quantity selectors
     ------------------------------------------------------------------ */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-quantity-change]');
    if (!btn) return;
    var wrap = btn.closest('.quantity-selector');
    var input = wrap && wrap.querySelector('input');
    if (!input) return;
    var delta = btn.dataset.quantityChange === 'down' ? -1 : 1;
    var min = parseInt(input.min || '1', 10);
    var next = Math.max(min, (parseInt(input.value, 10) || min) + delta);
    input.value = next;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ------------------------------------------------------------------
     Product gallery
     ------------------------------------------------------------------ */
  document.querySelectorAll('[data-product-gallery]').forEach(function (gallery) {
    var mainImages = gallery.querySelectorAll('[data-gallery-media]');
    var thumbs = gallery.querySelectorAll('[data-gallery-thumb]');

    var show = function (id) {
      mainImages.forEach(function (m) {
        m.hidden = m.dataset.galleryMedia !== id;
      });
      thumbs.forEach(function (t) {
        t.setAttribute('aria-current', t.dataset.galleryThumb === id ? 'true' : 'false');
      });
    };

    thumbs.forEach(function (t) {
      t.addEventListener('click', function () { show(t.dataset.galleryThumb); });
    });
  });

  /* ------------------------------------------------------------------
     Variant picker + product form
     ------------------------------------------------------------------ */
  document.querySelectorAll('[data-product-form-wrapper]').forEach(function (wrapper) {
    var dataEl = wrapper.querySelector('[data-product-json]');
    if (!dataEl) return;
    var product;
    try {
      product = JSON.parse(dataEl.textContent);
    } catch (err) {
      return;
    }

    var form = wrapper.querySelector('form[data-product-form]');
    var idInput = form && form.querySelector('input[name="id"]');
    var priceEl = wrapper.querySelector('[data-price]');
    var stickyPrice = document.querySelector('[data-sticky-price]');
    var stickyVariant = document.querySelector('[data-sticky-variant]');
    var addButton = form && form.querySelector('[data-add-to-cart]');

    var normalise = function (value) {
      return String(value == null ? '' : value).toLowerCase().replace(/\s+/g, '');
    };

    /* Every value each option actually takes, for checking that a value handed
       in from outside belongs to the option it claims to. */
    var valuesByOption = [];
    product.variants.forEach(function (v) {
      v.options.forEach(function (value, i) {
        if (!valuesByOption[i]) valuesByOption[i] = [];
        if (valuesByOption[i].indexOf(normalise(value)) === -1) {
          valuesByOption[i].push(normalise(value));
        }
      });
    });

    /* An options app (VO Product Options — see assets/product-options.js)
       renders its own controls and hides the theme's picker, so its choices
       are the only record of what the shopper picked. It reports them here:
       the option values it is showing, and the surcharge its priced extras add
       on top of the variant. */
    var appOptions = [];
    var appSurcharge = 0;

    var currentVariant = function () {
      var id = idInput && idInput.value;
      return product.variants.filter(function (v) {
        return String(v.id) === String(id);
      })[0] || product.variants[0];
    };

    var selectedOptions = function () {
      /* Seeded from the variant on the page so an option no visible control
         covers — one the app owns, or one on a hidden picker — keeps the value
         it already has instead of resolving to no variant at all. */
      var current = currentVariant();
      var opts = current ? current.options.slice() : [];
      wrapper.querySelectorAll('fieldset[data-option-index]').forEach(function (fs) {
        var checked = fs.querySelector('input[type="radio"]:checked');
        if (checked) opts[parseInt(fs.dataset.optionIndex, 10)] = checked.value;
      });
      appOptions.forEach(function (value, i) {
        if (value != null) opts[i] = value;
      });
      return opts;
    };

    /* Compared loosely: the app echoes the option values back as its own labels,
       which can differ from the catalogue's in case and spacing. */
    var findVariant = function (opts) {
      return product.variants.find(function (v) {
        return v.options.every(function (val, i) { return normalise(val) === normalise(opts[i]); });
      });
    };

    /* Show the selected variant plus the actual options surcharge. */
    var renderPrice = function (el, variant, surcharge) {
      if (!el || !variant) return;
      var price = variant.price + surcharge;
      var html = '<span class="price__sale">' + formatMoney(price) + '</span>';
      /* Write inside .price, not over it: that class carries the row's layout
         and type scale, and replacing it left every price after the first
         change unstyled. */
      var target = el.querySelector('.price');
      if (!target) {
        target = document.createElement('div');
        target.className = 'price';
        el.textContent = '';
        el.appendChild(target);
      }
      target.innerHTML = html;
    };

    var onVariantChange = function () {
      var variant = findVariant(selectedOptions());
      if (!variant) return;
      if (idInput) idInput.value = variant.id;
      renderPrice(priceEl, variant, appSurcharge);
      renderPrice(stickyPrice, variant, appSurcharge);
      /* "Default Title" is Shopify's placeholder for a product with no real
         options — the section marks that case so it never reaches a shopper. */
      if (stickyVariant && stickyVariant.dataset.singleton !== 'true') {
        stickyVariant.textContent = variant.title;
      }
      if (addButton) {
        addButton.toggleAttribute('disabled', !variant.available);
        var label = addButton.querySelector('[data-add-to-cart-text]');
        if (label) {
          label.textContent = variant.available
            ? (addButton.dataset.textAdd || 'Add to cart')
            : (addButton.dataset.textSoldOut || 'Sold out');
        }
      }
      if (window.history.replaceState && wrapper.dataset.updateUrl === 'true') {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      }
    };

    wrapper.querySelectorAll('fieldset[data-option-index] input[type="radio"]').forEach(function (r) {
      var onPick = function () {
        /* The shopper reached for the theme's own control, so it outranks
           whatever the app last reported for that option. The app mirrors the
           change a moment later and reports it again. */
        var fieldset = r.closest('fieldset[data-option-index]');
        var index = fieldset ? parseInt(fieldset.dataset.optionIndex, 10) : NaN;
        if (!isNaN(index)) appOptions[index] = null;
        onVariantChange();
      };
      /* Both events, because they cover different gestures: clicking a value
         the app has moved away from leaves the radio already checked and fires
         no change at all, and a keyboard pick fires change without a click.
         Running twice on an ordinary click is harmless — this only recomputes. */
      r.addEventListener('change', onPick);
      r.addEventListener('click', onPick);
    });

    /* Entry point for assets/product-options.js, which reads the options app's
       markup and calls this whenever the shopper touches it. Values arrive
       keyed by the app's own widget index; an index that does not hold the
       value is corrected rather than trusted, because a mis-keyed value would
       resolve to a variant other than the one on screen and the shopper would
       be charged for it. */
    var setAppSelection = function (selection) {
      var next = [];
      ((selection && selection.options) || []).forEach(function (value, i) {
        var needle = normalise(value);
        if (!needle) return;
        var index = -1;
        if (valuesByOption[i] && valuesByOption[i].indexOf(needle) !== -1) {
          index = i;
        } else {
          for (var j = 0; j < valuesByOption.length; j++) {
            if (valuesByOption[j].indexOf(needle) !== -1) {
              index = j;
              break;
            }
          }
        }
        if (index !== -1) next[index] = value;
      });

      var surcharge = Math.round(Number(selection && selection.surcharge) || 0);
      if (!(surcharge > 0)) surcharge = 0;

      /* The app rebuilds its markup on every interaction and this is read back
         several times per change, so most calls repeat the state already
         rendered. */
      if (surcharge === appSurcharge && JSON.stringify(next) === JSON.stringify(appOptions)) return;
      appOptions = next;
      appSurcharge = surcharge;
      onVariantChange();
    };

    window.themeProduct = { setAppSelection: setAppSelection };

    /* Pre-select a default option value (e.g. a 16x20 size) when the shopper
       arrived without an explicit ?variant=. Matched on a space- and
       case-insensitive substring so one setting covers "16x20in / 40x50cm"
       and "16x20 Inches" alike. Ported from the temp-ecs storefront, where
       the value was hard-coded; here it is a section setting. */
    var defaultOption = normalise(wrapper.dataset.defaultOption);

    if (defaultOption && !new URLSearchParams(window.location.search).get('variant')) {
      var candidates = Array.prototype.filter.call(
        wrapper.querySelectorAll('fieldset[data-option-index] input[type="radio"]'),
        function (r) { return normalise(r.value).indexOf(defaultOption) !== -1; }
      );
      /* Leave a product that lacks the value, or already has it, untouched. */
      var alreadyChosen = candidates.some(function (r) { return r.checked; });
      if (candidates.length && !alreadyChosen) {
        /* Prefer a value that resolves to a purchasable variant. */
        var preferred = candidates.filter(function (r) {
          var trial = selectedOptions();
          trial[parseInt(r.closest('fieldset[data-option-index]').dataset.optionIndex, 10)] = r.value;
          var candidate = findVariant(trial);
          return candidate && candidate.available;
        })[0] || candidates[0];
        preferred.checked = true;
        onVariantChange();
      }
    }

    /* AJAX add to cart */
    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (addButton) addButton.setAttribute('disabled', '');
        var body = new FormData(form);
        fetch((window.theme && window.theme.routes && window.theme.routes.cartAdd) || '/cart/add.js', {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: body
        })
          .then(function (r) {
            if (!r.ok) return r.json().then(function (j) { throw j; });
            return r.json();
          })
          .then(function () {
            return refreshCart(true);
          })
          .catch(function (err) {
            var msg = (err && (err.description || err.message)) || 'Unable to add to cart';
            var status = form.querySelector('[data-form-status]');
            if (status) {
              status.textContent = msg;
              status.hidden = false;
            }
          })
          .finally(function () {
            if (addButton) addButton.removeAttribute('disabled');
          });
      });
    }
  });

  /* ------------------------------------------------------------------
     Cart: drawer refresh, quantity updates, count bubble
     ------------------------------------------------------------------ */
  var refreshCart = function (open) {
    var drawer = document.querySelector('[data-cart-drawer]');
    var requests = [
      fetch((window.theme && window.theme.routes && window.theme.routes.cart) || '/cart.js', {
        headers: { Accept: 'application/json' }
      }).then(function (r) { return r.json(); })
    ];
    if (drawer) {
      requests.push(
        fetch(window.location.pathname + '?sections=' + drawer.dataset.sectionId)
          .then(function (r) { return r.json(); })
      );
    }
    return Promise.all(requests).then(function (results) {
      var cart = results[0];
      document.querySelectorAll('[data-cart-count]').forEach(function (el) {
        el.textContent = cart.item_count > 0 ? cart.item_count : '';
      });
      if (drawer && results[1]) {
        var html = results[1][drawer.dataset.sectionId];
        if (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.querySelector('[data-cart-drawer-content]');
          var current = drawer.querySelector('[data-cart-drawer-content]');
          if (fresh && current) current.replaceWith(fresh);
        }
        if (open) openDrawer(drawer);
      }
      return cart;
    });
  };

  window.themeCart = { refresh: refreshCart };

  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-cart-line-quantity]');
    if (!input) return;
    fetch((window.theme && window.theme.routes && window.theme.routes.cartChange) || '/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: parseInt(input.dataset.cartLineQuantity, 10), quantity: parseInt(input.value, 10) || 0 })
    })
      .then(function (r) { return r.json(); })
      .then(function () {
        if (document.querySelector('[data-cart-page]')) {
          window.location.reload();
        } else {
          refreshCart(false);
        }
      });
  });

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-cart-line-remove]');
    if (!btn) return;
    e.preventDefault();
    fetch((window.theme && window.theme.routes && window.theme.routes.cartChange) || '/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: parseInt(btn.dataset.cartLineRemove, 10), quantity: 0 })
    })
      .then(function (r) { return r.json(); })
      .then(function () {
        if (document.querySelector('[data-cart-page]')) {
          window.location.reload();
        } else {
          refreshCart(false);
        }
      });
  });

  /* ------------------------------------------------------------------
     Sticky buy bar (product pages)
     ------------------------------------------------------------------ */
  var stickyBar = document.querySelector('[data-sticky-buy-bar]');
  var buyBox = document.querySelector('[data-product-buy-box]');
  if (stickyBar && buyBox && 'IntersectionObserver' in window) {
    var observer = new IntersectionObserver(
      function (entries) {
        stickyBar.classList.toggle('is-visible', !entries[0].isIntersecting && entries[0].boundingClientRect.top < 0);
      },
      { threshold: 0 }
    );
    observer.observe(buyBox);
    var stickySubmit = stickyBar.querySelector('[data-sticky-add]');
    if (stickySubmit) {
      stickySubmit.addEventListener('click', function () {
        var form = document.querySelector('form[data-product-form]');
        if (form) form.requestSubmit();
      });
    }
  }

  /* ------------------------------------------------------------------
     Search now lives in assets/site-search.js (hero + header drawer share
     one engine). The predictive block that used to live here is gone.
     ------------------------------------------------------------------ */

  /* ------------------------------------------------------------------
     Header mega menu — hover-open with close delay; flips the
     transparent header opaque while a panel is open.
     ------------------------------------------------------------------ */
  document.querySelectorAll('header-component').forEach(function (header) {
    var closeTimer = null;

    var closeAll = function () {
      header.querySelectorAll('[data-mega-panel]').forEach(function (p) {
        p.hidden = true;
        var a = p.parentElement.querySelector('a[aria-haspopup]');
        if (a) a.setAttribute('aria-expanded', 'false');
      });
      header.classList.remove('header--menu-open');
    };

    var open = function (li) {
      clearTimeout(closeTimer);
      closeAll();
      var panel = li.querySelector('[data-mega-panel]');
      if (!panel) return;
      panel.hidden = false;
      var a = li.querySelector('a[aria-haspopup]');
      if (a) a.setAttribute('aria-expanded', 'true');
      header.classList.add('header--menu-open');
    };

    var scheduleClose = function () {
      clearTimeout(closeTimer);
      closeTimer = setTimeout(closeAll, 150);
    };

    header.querySelectorAll('[data-menu-item]').forEach(function (li) {
      var hasPanel = !!li.querySelector('[data-mega-panel]');
      li.addEventListener('mouseenter', function () {
        if (hasPanel) open(li);
        else scheduleClose();
      });
      li.addEventListener('mouseleave', scheduleClose);
      var a = li.querySelector('a[aria-haspopup]');
      if (a) {
        a.addEventListener('focus', function () { open(li); });
        a.addEventListener('click', function (e) {
          if (window.matchMedia('(hover: none)').matches) {
            var panel = li.querySelector('[data-mega-panel]');
            if (panel && panel.hidden) {
              e.preventDefault();
              open(li);
            }
          }
        });
      }
    });

    header.querySelectorAll('[data-mega-panel]').forEach(function (panel) {
      panel.addEventListener('mouseenter', function () { clearTimeout(closeTimer); });
      panel.addEventListener('mouseleave', scheduleClose);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeAll();
    });
    document.addEventListener('click', function (e) {
      if (!header.contains(e.target)) closeAll();
    });
  });

  /* ------------------------------------------------------------------
     Rotating hero backgrounds
     ------------------------------------------------------------------ */
  document.querySelectorAll('[data-hero-rotate]').forEach(function (hero) {
    var layers = hero.querySelectorAll('[data-hero-bg]');
    if (layers.length < 2) return;
    var index = 0;
    var interval = parseInt(hero.dataset.heroRotate || '6000', 10);
    setInterval(function () {
      index = (index + 1) % layers.length;
      layers.forEach(function (l, i) {
        l.style.opacity = i === index ? '1' : '0';
      });
    }, interval);
  });

  /* ------------------------------------------------------------------
     Facets: auto-submit filter form
     ------------------------------------------------------------------ */
  document.querySelectorAll('form[data-facets-form]').forEach(function (form) {
    form.addEventListener('change', function (e) {
      if (e.target.matches('input[type="checkbox"], select')) form.submit();
    });
  });
})();


